import React from 'react'
import { connect } from 'react-redux'
import { localized } from 'decorators'
import { Page } from 'components/page'
import { Icon } from 'components/icons'
import { LinkButton } from 'components/buttons'
import { useStyles } from './selector.css'

export const createSelectorPage = ({ metadata }) => {

  const findChildren = (entity) => {
    if (entity) {
      if (entity.sideBarMenuItems) {
        const x = entity.sideBarMenuItems.find(x => x.path === metadata.baseUrl)
        if (x && x.children) { return x.children }
      }
    }
    return []
  }

  const Item = ({ item, localize, className }) => {
    return (
      <div className={className}>
        <LinkButton href={item.path}><Icon name={item.iconName} />{localize(item.displayName)}</LinkButton>
      </div>
    )
  }

  return connect(
    ({ applicationMenu }) => ({ applicationMenu }))
    (localized(({ localize, applicationMenu }) => {
    const classes = useStyles()
    const { entity } = applicationMenu
    const items = findChildren(entity)
    return (
      <Page
        title={localize(metadata.title)}
        metadata={{}}
        hideGoBack
        canCreate={false}
        canGoToTrash={false}
        localize={localize}>
        {items.map((x, idx) => <Item key={idx} className={classes.item} item={x} localize={localize} />)}
      </Page>
    )
  }))
}
